import { render, staticRenderFns } from "./user_promotion_record.vue?vue&type=template&id=8f4719ce&scoped=true"
import script from "./user_promotion_record.vue?vue&type=script&lang=ts"
export * from "./user_promotion_record.vue?vue&type=script&lang=ts"
import style0 from "./user_promotion_record.vue?vue&type=style&index=0&id=8f4719ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4719ce",
  null
  
)

export default component.exports